import { Col, Row } from "antd";
import { CustomTag } from "../../../Tags";

interface AddressFormProps {
  street?: string;
  zibun?: string;
  detail?: string;
}

/**
 * 도로명주소 및 지번주소 처리 폼
 * @param param0
 * @returns
 */
export const AddressForm: React.FC<AddressFormProps> = ({
  street,
  zibun,
  detail,
}) => {
  return (
    <>
      {street || zibun ? (
        <Row gutter={[0, 4]}>
          {street && (
            <Col span={24}>
              <Row gutter={4} wrap={false} align="top">
                <Col>
                  <CustomTag
                    colors="black"
                    style={{
                      width: 50,
                      textAlign: "center",
                    }}
                  >
                    도로명
                  </CustomTag>
                </Col>
                <Col>
                  {street}
                  {detail && ` ${detail}`}
                </Col>
              </Row>
            </Col>
          )}
          {zibun && (
            <Col span={24}>
              <Row gutter={4} wrap={false} align="top">
                <Col>
                  <CustomTag
                    colors="black"
                    style={{
                      width: 50,
                      textAlign: "center",
                    }}
                  >
                    지번
                  </CustomTag>
                </Col>
                <Col>
                  {zibun}
                  {detail && ` ${detail}`}
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      ) : (
        "-"
      )}
    </>
  );
};
